export const ALGOLIA_APP_ID = "IAALSBRLTF";
export const ALGOLIA_SEARCH_API_KEY = "3eda9d4a1756bc68dc26f2ca5cd41e9b";
export const ALGOLIA_INDEX_NAME = "projects";
export const ALGOLIA_FACETS = [
  "client",
  "company",
  "projectManager",
  "projectStatus",
  "paymentStatus",
  "poc",
];

export const SORT_INDEXES = {
  "createdAt:asc": "projects_sort_createdAt_asc",
  "createdAt:desc": "projects_sort_createdAt_desc",
  "projectRef:asc": "projects_sort_projectRef_asc",
  "projectRef:desc": "projects_sort_projectRef_desc",
  "projectManager:asc": "projects_sort_projectManager_asc",
  "projectManager:desc": "projects_sort_projectManager_desc",
  "client:asc": "projects_sort_client_asc",
  "client:desc": "projects_sort_client_desc",
  "amountIncVat:asc": "projects_sort_amountIncVat_asc",
  "amountIncVat:desc": "projects_sort_amountIncVat_desc",
  "income:asc": "projects_sort_income_asc",
  "income:desc": "projects_sort_income_desc",
};

// Helper to build Algolia filter string from UI filters
export const buildUiFiltersString = (filters = {}, options = {}) => {
  const { omitFacets = [] } = options;
  const omitSet = new Set(omitFacets);
  const esc = (s) => String(s).replace(/'/g, "\\'");
  const groups = [];

  const createGroup = (field, values) => {
    if (values && values.length > 0) {
      const group = values.map((v) => `${field}:'${esc(v)}'`).join(" OR ");
      groups.push(`(${group})`);
    }
  };

  if (!omitSet.has("client")) {
    createGroup("client", filters.client);
  }
  if (!omitSet.has("billingEntity") && !omitSet.has("company")) {
    createGroup("company", filters.billingEntity);
  }
  if (!omitSet.has("projectManager")) {
    createGroup("projectManager", filters.projectManager);
  }
  if (!omitSet.has("projectStatus")) {
    createGroup("projectStatus", filters.projectStatus);
  }
  if (!omitSet.has("paymentStatus")) {
    createGroup("paymentStatus", filters.paymentStatus);
  }
  if (!omitSet.has("poc")) {
    createGroup("poc", filters.poc);
  }

  return groups.join(" AND ");
};

// Helper to build numeric filters for date range
export const buildNumericFilters = (filters = {}) => {
  if (
    !filters.date ||
    !filters.date.length ||
    !filters.date[0].startsWith("range:")
  )
    return undefined;

  const [, startISO, endISO] = filters.date[0].split(":");
  const startMs = Date.parse(startISO);
  const endMs = Date.parse(endISO);
  if (isNaN(startMs) || isNaN(endMs)) return undefined;
  // Include full end day
  return [
    `createdAt>=${startMs}`,
    `createdAt<=${endMs + (24 * 60 * 60 * 1000 - 1)}`,
  ];
};
